import { tr, uiLocale } from '@/i18n/copy';
import { TermsContent } from './CommercialTerms';

export default function AnnualOffer({ offer, docs }) {
  const euros = value => (value / 100).toLocaleString(uiLocale(), { style: 'currency', currency: 'EUR' });
  const groups = [];
  for (const part of offer.annual_components || []) {
    const last = groups[groups.length - 1];
    if (last && last.amount === part.amount && last.kind === part.kind) last.months += 1;
    else groups.push({ ...part, months: 1 });
  }
  return <div className="space-y-3">
    <span className="inline-flex rounded-full border border-emerald-500/40 bg-emerald-500/10 px-3 py-1.5 text-xs font-semibold text-emerald-600 dark:text-emerald-400">{tr('12 mesi al prezzo di 11')}</span>
    <p className="text-sm">{tr('Un unico pagamento di {{0}} per 12 mesi di servizio.', { '0': euros(offer.amount) })}</p>
    <p className="text-xs text-muted-foreground">{tr('Risparmi {{0}} rispetto ai pagamenti mensili equivalenti ({{1}}).', { '0': euros(offer.annual_saving), '1': euros(offer.monthly_comparison_amount) })}</p>
    <details className="rounded-xl border p-3 text-sm">
      <summary className="cursor-pointer font-semibold">{tr('Calcolo annuale e condizioni')}</summary>
      <div className="mt-3 space-y-3">
        {groups.map((part, i) => <p key={i}>{tr('{{0}} mesi a {{1}} al mese', { '0': part.months, '1': euros(part.amount) })}{part.kind === 'promotion' ? ` · ${tr('con codice sconto')}` : ''}</p>)}
        <p>{tr('Al totale delle 12 mensilità si applica il fattore 11/12, arrotondato al centesimo. Tariffe iniziali e coupon valgono solo per i mesi spettanti.')}</p>
        {offer.promotion && <p>{tr('Codice {{0}} · durata {{1}} mesi', { '0': offer.promotion.code, '1': offer.promotion.months })}</p>}
        <p>{tr('Rinnovo ogni 12 mesi secondo le condizioni accettate, salvo disdetta. Il totale del periodo pagato resta fermo. I requisiti Brand vengono verificati a ogni rinnovo.')}</p>
        <p>{tr('Tariffa ordinaria annuale: {{0}}, salvo offerte e benefici applicabili.', { '0': euros(offer.standard_amount) })}</p>
        <TermsContent docs={docs} />
      </div>
    </details>
  </div>;
}
